import { render } from "./FrozenDetail.vue?vue&type=template&id=64203135&scoped=true"
import script from "./FrozenDetail.vue?vue&type=script&lang=js"
export * from "./FrozenDetail.vue?vue&type=script&lang=js"

import "./FrozenDetail.vue?vue&type=style&index=0&id=64203135&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64203135"]])

export default __exports__